import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import { CLIENT_MANUFACTURER_PRODUCT } from 'lib/networking/endpoints';
import { CUT_DRY_CLIENT_ID } from 'lib/constants';
import { amber, grape, green, grey } from 'lib/css/colors';
import { InfluenceStatus } from 'lib/enums/InfluenceStatus';
import useGet from 'lib/hooks/useGet';

// Read-only: campaign status comes from the C+D import (product-level), not edited in FSA.
function resolveCampaignStatus(campaignStatus) {
  if (campaignStatus === InfluenceStatus.ACTIVE) {
    return { label: 'Campaign Active', color: green };
  }
  if (campaignStatus === InfluenceStatus.DRAFT) {
    return { label: 'Campaign Draft', color: amber };
  }
  return { label: 'Not in Campaign', color: grey };
}

function InfluenceCampaignStatus({ productId }) {
  const [campaignStatus, setCampaignStatus] = useState(null);

  const { data: { data: clientMfrProduct } = {} } = useGet(
    CLIENT_MANUFACTURER_PRODUCT,
    { product_id: productId, client_id: CUT_DRY_CLIENT_ID },
    !productId,
  );

  useEffect(() => {
    setCampaignStatus(clientMfrProduct?.influence_campaign_status ?? null);
  }, [clientMfrProduct]);

  const status = resolveCampaignStatus(campaignStatus);

  return (
    <div className={css(styles.container)}>
      <span className={css(styles.label)}>Influence Campaign</span>
      <span
        className={css(styles.pill)}
        style={{ backgroundColor: `${status.color}20`, color: status.color }}
      >
        {status.label}
      </span>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 18px',
    backgroundColor: '#fff',
    borderRadius: '24px',
    border: `1px solid ${grape}30`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: grape,
    userSelect: 'none',
  },
  pill: {
    fontSize: '12px',
    fontWeight: '600',
    padding: '2px 10px',
    borderRadius: '12px',
    whiteSpace: 'nowrap',
  },
});

InfluenceCampaignStatus.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default InfluenceCampaignStatus;
